export enum DiscountTypeEnumPromotion {
    AMOUNT = 'AMOUNT',
    PERCENT = "PERCENT"
}

export enum PromotionTypeEnumPromotion {
    PROMOTION = 'promotion',
    PER_DAY = "per_day"
}